import React from 'react';
import './heading.css'
const HeadingBlock = (props) => {
    return (<>
    <div className={`headingBlock ${props.style1}`}>
        <h6 className='regular'>{props.label}</h6>
        <h1>
{props.heading}
    </h1>

    <h3 className='scaleIn scrollAnimate2'>
{props.subheading}
    </h3>
    </div>
    </>  );
}
 
export default HeadingBlock;